import script from "./TextTool.vue?vue&type=script&lang=js"
export * from "./TextTool.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__